<ng-container *ngIf="fantasyHistory$ | async as fantasyHistory">
  <ng-container *ngIf="fantasyHistory.length > 0; else noPlayerHistory">
    <div class="card border rounded px-2 mx-1">
      <ng-container *ngFor="let item of fantasyHistory">
        <fgb-fantasy-history-list-item [fantasyHistoryItem]="item"></fgb-fantasy-history-list-item>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #noPlayerHistory>
    <div class="bg-white no-items w-100 text-center border rounded pt-5 p-4 mt-4">
      <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/games/Results.svg'"></div>
      <p class="text-black text-center font-size-14 mt-2 mb-0">{{ 'pick.player.history.placeholder.description' | translate }}</p>
    </div>
  </ng-template>
</ng-container>
